import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Star, Heart, Award } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AspectRatio } from "@/components/ui/aspect-ratio";

export const Benefits = () => {
  const { t } = useTranslation();

  const benefits = [
    { 
      icon: Star, 
      key: 'visibility', 
      color: '#FFE66D',
      strokeWidth: 2.5,
      size: 24,
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80'
    },
    { 
      icon: Heart, 
      key: 'community', 
      color: '#ea384c',
      strokeWidth: 2,
      size: 24,
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80'
    },
    { 
      icon: Award, 
      key: 'opportunities', 
      color: '#7FC8A9',
      strokeWidth: 2.5,
      size: 24,
      image: 'https://images.unsplash.com/photo-1649972904349-6e44c42644a7?auto=format&fit=crop&q=80'
    }
  ];

  return (
    <div className="container mx-auto px-4 py-16 bg-gray-50">
      <h2 className="text-3xl font-bold text-center mb-12">{t('benefits.title')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {benefits.map(({ icon: Icon, key, color, strokeWidth, size, image }) => (
          <Card key={key} className="overflow-hidden">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Icon 
                  className="flex-shrink-0" 
                  color={color} 
                  fill={color} 
                  strokeWidth={strokeWidth}
                  size={size}
                />
                {t(`benefits.${key}.title`)}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600">{t(`benefits.${key}.description`)}</p>
              <AspectRatio ratio={16 / 9} className="bg-muted">
                <img
                  src={image}
                  alt={t(`benefits.${key}.title`)}
                  className="rounded-md object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                />
              </AspectRatio>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};